// «Записать»: клиент, тип, день, свободное время (в любом из поясов), встреча, цена, резерв вариантами, повтор.
import { MEET, RU_DAYS, RU_DAYS_FULL, addDays, cityDative, dowOf, isDateStr, minToHm, money, plural, repeatLabel, ruDate,
  ruDateShort, tzCity, windowStarts, type Every } from '@praktika/core';
import { afterChange, call } from '../lib/api.ts';
import { ensureBusy } from '../lib/busy.ts';
import { $, $$, esc } from '../lib/dom.ts';
import { activeTypes, clientById, defaultType, groupOf, meetLabel, typeById, windowsOf, workOf } from '../lib/data.ts';
import { SCREENS, back, render, title } from '../lib/nav.ts';
import { closeSheet, kvTog, openSheet, opt, promptSheet } from '../lib/sheet.ts';
import { S, UI, type BookDraft } from '../lib/state.ts';
import { convertTime, extraZones, nowInfo } from '../lib/zones.ts';
import { bookPrice, meetSheet, pickClient } from './common.ts';

const EVERY: Array<[Every, string]> = [[1, 'каждую неделю'], [2, 'раз в 2 недели'], [3, 'раз в 3 недели'],
  [4, 'раз в 4 недели'], ['month', 'раз в месяц, то же число']];
const TIMES = [4, 8, 12, 26, 52];

SCREENS.book = (app, p) => {
  let b = UI.book;
  const key = JSON.stringify(p);
  if (!b || b.key !== key) {
    const c0 = p.clientId ? clientById(String(p.clientId)) : null;
    b = UI.book = { key, clientId: String(p.clientId || ''), typeId: c0 ? (c0.effTypeId || c0.typeId || '') : '',
      date: String(p.date || nowInfo().date), time: p.time !== undefined ? Number(p.time) : null, meet: '', link: '',
      address: '', price: '', repeat: 0, every: 1, note: '', tzView: String(p.view || ''), reserve: false, variants: [] };
  }
  const d: BookDraft = b, c = d.clientId ? clientById(d.clientId) : null;
  ensureBusy(d.date);
  const type = typeById(d.typeId || (c ? c.effTypeId || c.typeId : '') || defaultType().id);
  const starts: number[] = [];
  for (const w of windowsOf(d.date)) starts.push(...windowStarts(w, type));
  const validTime = d.time !== null && starts.includes(d.time);
  const isVar = (t: number) => d.variants.some((v) => v.date === d.date && v.time === t);
  const clientTz = c && c.tz && c.tz !== S.tz ? c.tz : '';
  // в каком поясе показывать времена: мой, пояс клиента, дополнительные пояса со шкалы
  const zopts = [{ tz: S.tz, label: tzCity(S.tz) + ' · моё' }];
  if (clientTz) zopts.push({ tz: clientTz, label: tzCity(clientTz) + ' · ' + (c!.callName || c!.name) });
  for (const z of extraZones()) if (z !== clientTz) zopts.push({ tz: z, label: tzCity(z) });
  let viewTz = d.tzView || S.tz;
  if (!zopts.some((o) => o.tz === viewTz)) viewTz = S.tz;
  const lab = (t: number) => {
    if (viewTz === S.tz) return minToHm(t);
    const ct = convertTime(d.date, t, S.tz, viewTz);
    return minToHm(ct.min) + (ct.date !== d.date ? (ct.date > d.date ? '⁺' : '⁻') : '');
  };
  const shown = UI.expandTimes ? starts : starts.slice(0, 12);
  // что выбрано: в выбранном поясе крупно, рядом — как это у вас и у клиента
  const pickedNote = (t: number) => {
    const mine = minToHm(t), parts: string[] = [];
    if (viewTz !== S.tz) parts.push('<b>' + lab(t) + ' по ' + esc(cityDative(tzCity(viewTz))) + '</b> — у вас ' + mine);
    else parts.push('<b>Выбрано ' + mine + '</b> по вашему времени');
    if (clientTz && clientTz !== viewTz) parts.push('у клиента ' + minToHm(convertTime(d.date, t, S.tz, clientTz).min) +
      ' (' + esc(tzCity(clientTz)) + ')');
    return parts.join(', ') + '. В календарь запишется ' + mine + ' (' + esc(tzCity(S.tz)) + ').';
  };
  const work = workOf(d.date), g = groupOf(c), price = c ? bookPrice(c, type.id) : null;
  const html = title('Записать', '', false) +
    '<button class="field" data-pick-client><div class="l">Клиент</div><div class="v"><span>' + (c ? esc(c.name) +
      (g && !g.isDefault ? ' · ' + esc(g.name) : '') : '<span style="color:#9aa4b8;font-weight:400">выбрать…</span>') +
      '</span><span class="chev"></span></div></button>' +
    '<div class="card"><div class="hd">Тип сессии</div><div class="chips">' +
      activeTypes().map((t) => '<button class="chp' + (t.id === type.id ? ' on' : '') + '" data-type="' + esc(t.id) + '">' +
      esc(t.name) + ' ' + t.dur + '</button>').join('') + '</div></div>' +
    '<div class="field"><div class="l">День</div><div class="v">' +
      '<button data-day="-1" style="font-size:22px;padding:0 10px">‹</button>' +
      '<span style="flex:1;text-align:center">' + esc(RU_DAYS_FULL[dowOf(d.date)] + ', ' + ruDate(d.date)) +
      '</span><button data-day="1" style="font-size:22px;padding:0 10px">›</button></div><input type="date" value="' +
      d.date + '" data-date style="position:absolute;opacity:0;width:1px;height:1px"></div>' +
    '<div class="card"><div class="hd">Свободное время · с перерывом ' + type.brk +
      (work && work.lunchStart !== null ? ' и обедом' : '') + '</div>' +
    (zopts.length > 1 ? '<div class="zv"><span class="l">Время по:</span>' + zopts.map((o) => '<button class="tzc' +
      (o.tz === viewTz ? ' on main' : '') + '" data-tz="' + esc(o.tz) + '">' + esc(o.label) + '</button>').join('') +
      '</div>' : '') +
    '<div class="chips">' + (starts.length ? shown.map((t) => '<button class="chp' +
      ((d.reserve ? isVar(t) : t === d.time) ? ' on' : '') + '" data-time="' + t + '">' + lab(t) + '</button>').join('') +
      (starts.length > shown.length ? '<button class="chp dis" data-more>ещё ' + (starts.length - shown.length) +
      '</button>' : '') : '<span class="small">' + (work ? 'в этот день окон под ' + esc(type.name) + ' нет' :
      'выходной') + '</span>') + '</div>' +
    (!d.reserve && validTime ? '<p class="p-note picked" style="padding:0 14px 10px">' + pickedNote(d.time!) + '</p>' : '') +
    (d.reserve ? '<div class="vars"><span class="l">Варианты:</span>' + (d.variants.length ? d.variants.map((v, i) =>
      '<button class="var" data-var="' + i + '">' + esc(RU_DAYS[dowOf(v.date)]!.toLowerCase() + ' ' + ruDateShort(v.date) +
      ' ' + minToHm(v.time)) + ' ✕</button>').join('') : '<span class="small">нажмите время — добавится вариант; ' +
      'можно выбрать в разные дни</span>') + '</div>' : '') + '</div>' +
    '<div class="card"><button class="kv" data-meet><span class="k">Встреча</span><span class="v chev">' +
      esc(meetLabel({ meet: d.meet || (c ? c.meet : S.settings.meet_kind_default), link: d.link || (c ? c.link : ''),
      address: d.address || (c ? c.address : '') })) + '</span></button>' +
    '<button class="kv" data-price><span class="k">Цена</span><span class="v chev">' +
      (price ? esc(money(d.price !== '' ? Number(d.price) : price.price, price.cur)) : '—') + '</span></button>' +
    kvTog('Резерв — несколько вариантов', d.reserve, 'data-reserve') +
    (d.reserve ? '' : '<button class="kv" data-repeat><span class="k">Повторять</span><span class="v chev">' +
      (d.repeat > 1 ? repeatLabel(d.every) + ', ' + d.repeat + ' раз' : 'нет') + '</span></button>') +
    '<div class="kv"><span class="k">Комментарий</span><input data-note value="' + esc(d.note) +
      '" placeholder="необязательно" style="flex:1;text-align:right;border:0;outline:0"></div></div>' +
    (d.reserve ? '<div class="btnrow"><button class="btn pri" data-save' + (c && d.variants.length ? '' : ' disabled') +
      '>Зарезервировать' + (d.variants.length ? ' ' + d.variants.length + ' ' + plural(d.variants.length, 'вариант',
      'варианта', 'вариантов') : '') + '</button></div>' :
      '<div class="btnrow"><button class="btn pri" data-save' + (c && validTime ? '' : ' disabled') + '>Записать' +
      (validTime ? ' на ' + RU_DAYS[dowOf(d.date)]!.toLowerCase() + ' ' + lab(d.time!) +
      (viewTz !== S.tz ? ' по ' + cityDative(tzCity(viewTz)) : '') : '') + '</button></div>') +
    '<p class="p-note">' + (c && c.meet === MEET.MEET ? 'Событие уйдёт в календарь «Сессии», ссылка Meet создастся сама.' :
      'Событие уйдёт в календарь «Сессии».') + '</p>';
  app.innerHTML = html;
  $('[data-pick-client]', app).onclick = () => pickClient((id) => {
    const cc = clientById(id);
    d.clientId = id;
    d.typeId = cc ? cc.effTypeId || cc.typeId || '' : '';
    d.price = '';
    d.meet = '';
    d.time = null;
    render();
  });
  $$('[data-type]', app).forEach((x) => { x.onclick = () => { d.typeId = x.getAttribute('data-type')!; d.time = null; render(); }; });
  $$('[data-day]', app).forEach((x) => {
    x.onclick = () => { d.date = addDays(d.date, Number(x.getAttribute('data-day'))); d.time = null; UI.expandTimes = false; render(); };
  });
  const di = $<HTMLInputElement>('[data-date]', app);
  di.onchange = () => { if (isDateStr(di.value)) { d.date = di.value; d.time = null; render(); } };
  const dayLabel = $('.field .v span[style]', app);
  if (dayLabel) dayLabel.onclick = () => { try { di.showPicker(); } catch { di.click(); } };
  $$('[data-tz]', app).forEach((x) => { x.onclick = () => { d.tzView = x.getAttribute('data-tz')!; render(); }; });
  $$('[data-time]', app).forEach((x) => {
    x.onclick = () => {
      const t = Number(x.getAttribute('data-time'));
      if (d.reserve) {
        const i = d.variants.findIndex((v) => v.date === d.date && v.time === t);
        if (i >= 0) d.variants.splice(i, 1);
        else d.variants.push({ date: d.date, time: t });
      } else d.time = t;
      render();
    };
  });
  $$('[data-var]', app).forEach((x) => { x.onclick = () => { d.variants.splice(Number(x.getAttribute('data-var')), 1); render(); }; });
  $('[data-reserve]', app).onclick = () => {
    d.reserve = !d.reserve;
    if (d.reserve && d.time !== null && validTime && !d.variants.length) d.variants.push({ date: d.date, time: d.time });
    render();
  };
  const more = $('[data-more]', app);
  if (more) more.onclick = () => { UI.expandTimes = true; render(); };
  $('[data-meet]', app).onclick = () => meetSheet(d, c, render);
  $('[data-price]', app).onclick = () => {
    if (!c || !price) return;
    promptSheet('Цена за эту сессию', d.price !== '' ? d.price : price.price, 'number', (v) => {
      d.price = v === '' ? '' : Number(v);
      render();
    });
  };
  const rp = $('[data-repeat]', app);
  if (rp) rp.onclick = () => {
    const sh = openSheet('<div class="ttl">Повторять</div>' +
      '<p class="sub">В то же время, пока окно свободно. Две сессии в неделю: запишите каждый день отдельно, обе с повтором.</p>' +
      '<p class="sub"><b>Как часто</b></p>' +
      EVERY.map((e) => opt(String(e[0]) === String(d.every || 1) ? 'ok' : '', '', e[1])).join('') +
      '<p class="sub"><b>Сколько раз</b></p>' + opt(!d.repeat ? 'ok' : '', '', 'не повторять') +
      TIMES.map((n) => opt(n === d.repeat ? 'ok' : '', '', n + ' раз')).join(''));
    const bs = $$('button.opt', sh);
    EVERY.forEach((e, i) => { bs[i]!.onclick = () => { d.every = e[0]; if (!d.repeat) d.repeat = 8; closeSheet(); render(); }; });
    bs[EVERY.length]!.onclick = () => { d.repeat = 0; closeSheet(); render(); };
    TIMES.forEach((n, i) => { bs[EVERY.length + 1 + i]!.onclick = () => { d.repeat = n; closeSheet(); render(); }; });
  };
  const note = $<HTMLInputElement>('[data-note]', app);
  note.oninput = () => { d.note = note.value; };
  $('[data-save]', app).onclick = () => {
    const payload = { clientId: d.clientId, date: d.date, time: d.reserve || d.time === null ? '' : minToHm(d.time),
      typeId: type.id, meet: d.meet || undefined, link: d.link || undefined, address: d.address || undefined,
      price: d.price === '' ? undefined : d.price, repeat: d.reserve ? 0 : d.repeat || 0, every: d.every || 1,
      note: d.note, reserve: d.reserve || undefined,
      variants: d.reserve ? d.variants.map((v) => ({ date: v.date, time: minToHm(v.time) })) : undefined };
    void call<{ count: number }>('createSession', payload).then((r) => {
      UI.book = null;
      return afterChange(d.reserve ? 'Резерв: ' + r.count + ' ' + plural(r.count, 'вариант', 'варианта', 'вариантов') :
        r.count > 1 ? 'Записано ' + r.count + ' сессий' : 'Записано').then(back);
    }, () => {});
  };
};
